import { CommandContext } from '../../../concepts/commands/CommandDefinition';
import { LabelValue } from '../../../platform/types/LabelValue';
import { Physical } from '../../canvas/entities/Physical';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { VoteCountAttr } from '../voting/Vote';
import { FlexSorter } from './FlexLayout';

export const AutoLayoutSortOptions = [
    LabelValue('None', 'none'),
    LabelValue('A-Z', 'az'),
    LabelValue('User', 'user'),
    LabelValue('Votes', 'votes'),
];

export type AutoLayoutSortType = (cc: CommandContext) => (a: Physical, b: Physical) => number;

export const AutoLayoutSort: Record<string, AutoLayoutSortType> = Object.freeze({

    none() {
        return FlexSorter.createComparer('row');
    },

    az() {
        return (a: Physical, b: Physical) => {
            const x = a.toText().localeCompare(b.toText());
            if (x === 0) return a.id.localeCompare(b.id);
            return x;
        };
    },

    user(cc: CommandContext) {
        const pm = cc.resolve(ParticipantManager);
        return (a: Physical, b: Physical) => {
            const au = a.has('userId') ? pm.get(a.get('userId')) : null;
            const bu = b.has('userId') ? pm.get(b.get('userId')) : null;
            if (!au && !bu) return a.id.localeCompare(b.id);
            if (!au) return 1;
            if (!bu) return -1;
            return au.name.localeCompare(bu.name);
        };
    },

    votes() {
        return (a: Physical, b: Physical) => {
            const av = VoteCountAttr.get(a);
            const bv = VoteCountAttr.get(b);
            if (av === null && bv === null) return a.id.localeCompare(b.id);
            if (av === null) return 1;
            if (bv === null) return -1;
            return bv - av;
        };
    },

});

